import { FC, MutableRefObject } from 'react'
import { useWindowSize } from 'react-use';
import { getStyledSectionWrapper } from '../../styled-components/SectionWrapper.styled';
import { MD_SCREEN } from '../../util/screen-size';
import { SectionWrapper } from '../wrappers/SectionWrapper.component'
import { HomeContent } from './HomeContent.component'

export interface HomeSectionProps {
    refItem: MutableRefObject<any>
}

export const HomeSection: FC<HomeSectionProps> = ({refItem}) => {

    const { width } = useWindowSize();

    const renderContent = () => {
        const size = width > MD_SCREEN

        if (size)
            return (
                <SectionWrapper >
                    <HomeContent />
                </SectionWrapper>
            )
        else
            return <HomeContent />
    }

    const StyledSectionWrapper = getStyledSectionWrapper()

    return (
        <StyledSectionWrapper ref={refItem}>
            {renderContent()}
        </StyledSectionWrapper>
    )
}